import { useIsVisible } from "@website/hooks/is-visible";
import omit from "lodash-es/omit";
import { Loader } from "next/dist/shared/lib/dynamic";
import dynamic from "next/dynamic";
import { useEffect, useState } from "react";

export const lazy = <T extends object>(loader: Loader<T>) =>
  function (properties: T) {
    const [isInView, setIsInView] = useState(false);

    const { reference, inView } = useIsVisible();

    useEffect(() => {
      inView && setIsInView(true);
    }, [inView]);

    if (!isInView) return <div ref={reference} />;

    const LazyComponent = dynamic(loader);

    return <LazyComponent {...(omit(properties, "loader") as T)} />;
  };
